import { render, staticRenderFns } from "@/client/budget/views/acceptance/choose-payment-method/choose-payment-method.pug?vue&type=template&id=41abbafc&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/client/budget/views/acceptance/choose-payment-method/choose-payment-method.scss?vue&type=style&index=0&id=41abbafc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41abbafc",
  null
  
)

export default component.exports